import React from 'react';
import {
  AppBar,
  Toolbar,
  Grid,
  Container,
  makeStyles,
} from '@material-ui/core';
import { Link as GLink } from 'gatsby';

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: '301',

    top: '85px',
    [theme.breakpoints.up('md')]: {
      top: '88px',
    },
    width: '100%',
    position: 'fixed',
    backgroundColor: 'rgba(255, 255, 255)',
    color: '#666666',
    borderColor: '#e1e1e1',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    textAlign: 'center',
  },
  menu: {
    height: '88px',
    textAlign: 'center',
    marginRight: '40px',
    lineHeight: '88px',
    color: '#333333',
    fontWeight: '600',
    fontSize: '1.4rem',
    float: 'left',
  },

  sticky: {
    height: '40px',
    position: 'relative',
    clear: 'both',
  },
  inner: {
    padding: '15px 0',
  },
  font: {
    textDecoration: 'none',
    color: '#919191',
    padding: '0px 8px',
    fontSize: '13px',
    '&:hover': {
      color: 'black',
    },
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

const useHeader = (props) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const classes = useStyles();

  return (
    <>
      <div className={classes.appBar}>
        <Container maxWidth="md">
          <div className={classes.sectionDesktop}>
            <Grid container>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/mam-solution"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>KeyFlow Enterprise</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/cms-solution"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>KeyFlow ADAMS</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/ingest-system"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>인제스트 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/nle-system"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>영상편집 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/storage-system"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>스토리지 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/archive-system"
                  className={classes.font}
                  activeClassName="subActive"
                >
                  <span>아카이브 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/work-with-apple"
                  className={classes.font}
                  activeClassName="subActive"
                >
                  <span>Work with Apple</span>
                </GLink>
              </Grid>
            </Grid>
          </div>
          <div className={classes.sectionMobile}>
            <Grid container>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/mam-solution"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>KeyFlow Enterprise</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/cms-solution"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>KeyFlow ADAMS</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/ingest-system"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>인제스트 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/nle-system"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>영상편집 시스템</span>
                </GLink>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/storage-system"
                  activeClassName="subActive"
                  className={classes.font}
                >
                  <span>스토리지 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/archive-system"
                  className={classes.font}
                  activeClassName="subActive"
                >
                  <span>아카이브 시스템</span>
                </GLink>
              </Grid>
              <Grid item xs className={classes.inner}>
                <GLink
                  to="/digital-media/work-with-apple"
                  className={classes.font}
                  activeClassName="subActive"
                >
                  <span>Work with Apple</span>
                </GLink>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
      <div className={classes.sticky} />
    </>
  );
};

export default useHeader;
